/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import api from '../utils/backend-api'
import router from '@/router'

import createPersistedState from 'vuex-persistedstate'

import Modules from './modules/Modules'
import Packages from './modules/Packages'
import AdminProfile from './modules/AdminProfile'
import Teachers from './modules/Teachers'
import Students from './modules/Student'
import studentdetails from './modules/Students'
import Notifications from './modules/Notifications'
import Clubs from './modules/Clubs'
import Products from './modules/Products'
import BlockList from './modules/BlockList'
import {
  Admin,
  Club
} from "../components/models";
import gallary from './modules/gallary'
Vue.use(Vuex)


export const store = new Vuex.Store({
  plugins:[createPersistedState()],
  modules: {
    Modules,
    Packages,
    AdminProfile,
    Teachers,
    Students,
    Notifications,
    Clubs,
    Products,
    BlockList,
    gallary,
    studentdetails,


  },
  state: {
    loading: '',
    pickuplocations: '',
    pagination: '',
    token: '',
    expireDate:'',
    pusherToken:'',
    admin: new Admin(),
    club: new Club(),
    schoolName: '',
    phone: '',
    startDate: '',
    description: '',
    benefits: '',
    opentime: '',
    closetime: '',
    email: '',
    adminname: '',
    adminphone: '',
    admingender: '',
    adminaddress: '',

    adminemail: '',
    adminpassword: '',
    policy: '',
    Fullname: '',
    claddress: '',
    CardNumber: '',
    ExpireDate: '',
    CVV: '',
    billingAddress: '',

    earningData: '',
    // modules: '',
    packages: '',
    studentData:'',
    teacherData:'',
    adminPackages:'',
    earningStatementData: '',
    totalEarning: '',
    earningChart: '',
    studentChart: '',
    teacherChart: '',
    studentClass: '',
    studentUpcomingClass: '',
    studentPastClass: '',
    studentFullClassDetails:'',
    // modules: '',
    packages: '',
    msg:'',
    success:false,
    user:'',
    Student:'',
    adminRes:'',
    teacherClass:'',
    chatMessages:[],
    chatSelectedUserId:''
  },
  mutations: {

    setLoading (state, {loading}) {
      state.loading = loading
    },
    setToken(state, token) {
      state.token = token
    },
    setPusherToken: (state, value) => {
      state.pusherToken = value;
    },
    setExpire: (state, value) => {
      state.expireDate = value.toString()
    },
    setUser(state, user) {
      state.user = user
    },
    setEarningsData (state, earnings) {
      state.earningData = earnings
    },
    setEarningsStatementData (state, earnings) {
      state.earningStatementData = earnings
    },
    setTotalEarning (state, earning) {
      state.totalEarning = earning
    },
    setEarningChart (state, earning) {
      state.earningChart = earning
    },
    setStudentChart (state, student) {
      state.studentChart = student
    },
    setTeacherChart (state, teacher) {
      state.teacherChart = teacher
    },
    setStudentDetails (state, student) {
      state.studentDetails = student
    },
    setStudentClass (state, student) {
      state.studentClassDetails = student
    },
    setStudentFullClass (state, student) {
      state.studentFullClassDetails = student
    },
    setTeacherEvents (state, teacher) {
      state.teacherEvents = teacher
    },
    setStoreTeacherEvents (state, teacher) {
      state.storeTeacherEvents = teacher
    },
    setTeacherClasses (state, teacher) {
          state.teacherClass = teacher
      },
    setStudentUpcomingClass (state, student) {
      state.studentUpcomingClass = student
    },
    setStudentPastClass (state, student) {
      state.studentPastClass = student
    },
    setModulesData (state, modules) {
      state.modules = modules
    },
    setPackagesData (state, packages) {
      state.packages = packages
    },
    setclub(state,{club}){
        this.club=club
    },
    setStudentData (state, studentData) {
      state.studentData = studentData
    },
    setTeacherData (state, teacherData) {
      state.teacherData = teacherData
    },
    setClubAdminNull(state) {
      state.Clubs = new Clubs()
      state.AdminProfile = new AdminProfile()
    },
    setAdminPackages(state, adminPackages) {
      state.adminPackages = adminPackages;
    },
    setLocations(state, pickuplocations) {
      state.pickuplocations = pickuplocations;
    },
    setMsg(state,{success,msg}) {
      state.success = success
      state.msg = msg
    },
    setadmin(state,{adminRes}) {
      state.adminRes = adminRes
    },
    setEmptyChatMessages(state){
      state.chatMessages=[]
    },
    setChatMessages(state,{messages,id}){
      state.chatMessages=[]
      state.chatMessages=messages
      state.chatSelectedUserId=id
    },
    pushChatMessages(state,{msg}){
      state.chatMessages.push(msg)
    },
    reset(state) {
      state.loading = ''
      state.pagination = ''
      state.token = ''
      state.expireDate = ''
      state.pusherToken = ''
      state.admin = ''
      state.club = ''
      state.schoolName = ''
      state.phone = ''
      state.startDate = ''
      state.description = ''
      state.benefits = ''
      state.opentime = ''
      state.closetime = ''
      state.email = ''
      state.adminname = ''
      state.adminphone = ''
      state.admingender = ''
      state.adminaddress = ''
      state.adminemail = ''
      state.adminpassword = ''
      state.policy = ''
      state.Fullname = ''
      state.claddress = ''
      state.CardNumber = ''
      state.ExpireDate = ''
      state.CVV = ''
      state.earningData = ''
      state.packages = ''
      state.studentData = ''
      state.teacherData = ''
      state.adminPackages = ''
      state.earningStatementData = ''
      state.totalEarning = ''
      state.earningChart = ''
      state.studentChart = ''
      state.teacherChart = ''
      state.studentClass = ''
      state.studentUpcomingClass = ''
      state.studentPastClass = ''
      state.packages = ''
      state.msg = ''
      state.success = ''
      state.user = ''
      state.Student = ''
      state.adminRes = ''
    }

  },
  getters: {

  },
  actions: {
    resetAccount({
      commit
    }, email) {
      commit("setLoading", {
        loading: true
      });
      var formData = new FormData();
      formData.append('email', email);
      return new Promise(function (resolve, reject) {
        api.postData("auth/recovery", formData)
          .then(res => {

            if (res.status == 200) {
              commit("setLoading", {
                loading: false
              });
              resolve(res.data);
            } else {
              commit("setLoading", {
                loading: false
              });
              reject(res.data);
            }
          })
          .catch(function (error) {
            commit("setLoading", {
              loading: false
            });
            reject(error);
          }).then(function () {
            reject("Done")
          })
      });
    },
    
    resetPassword({
      commit
      }, data) {
      return new Promise(function (resolve, reject) {
        api.postData("auth/reset", data)
          .then(res => {

            if (res.status == 200) {
              commit("setLoading", {
                loading: false
              });
              resolve(res.data);
            } else {
              commit("setLoading", {
                loading: false
              });
              reject(res.data);
            }
          })
          .catch(function (error) {
            commit("setLoading", {
              loading: false
            });
            reject(error);
          }).then(function () {
            reject("Done")
          })
      });
    },
    updateUser({commit}, {user,token,pusherToken,expireDate}) {
      commit("setToken", token)
      commit("setUser", user)
      commit('setPusherToken',pusherToken)
      commit('setExpire',expireDate)
    },
    logout({commit}) {
      commit("Modules/reset")
      commit("Packages/reset")
      commit("AdminProfile/reset")
      commit("Teachers/reset")
      commit("Students/reset")
      commit("studentdetails/reset")
      commit("Notifications/reset")
      commit("Clubs/reset")
      commit("Products/reset")
      commit("BlockList/reset")
      commit("reset")
      localStorage.removeItem('vuex')
      // commit("setNotice", {})
      // commit("setSnackbar", {})
      // commit("setUser", {})
      // commit("setadmin", {})
      // commit("setclub", {})
      // commit("setToken", null)
      // commit("setOrderList", {})
      // commit("setCustomers", {})
      // commit("setPagination", {})
      // commit("setLoading", {})
      // commit("setNotice", {})
      // commit("setSnackbar", {})
      // commit("setMode", {})
      // commit("setCustomer", {})
      // commit("setCustomersData", {})
      // commit("setEarning", {})
      // commit("setTotalEarning", {})
      // commit("setEarningChart", {})
      // commit("setStudentChart", {})
      // commit("setTeacherChart", {})
      // commit("setStudentDetails", {})
      // commit("setStudentClass", {})
      // commit("setTeacherEvents", {})
      // commit("setStoreTeacherEvents", {})
      // commit("setPackagesData", {})
      // commit("setStudentData", {})
      // commit("setTeacherData", {})
      // commit("setClubAdminNull", {})
      // commit("setAdminPackages", {})
      // commit("setMsg", {})
      // commit("setEarningsData", {})
      // commit("setEarningsStatementData", {})
      // commit("setWithdrawData", {})
      // commit("setEarningChart", {})
      // commit("setStudentChart", {})
      // commit("setTeacherChart", {})
      // commit("setStudentClass", {})
      // commit("setStudentDetails", {})
      // commit("setTeacherEvents", {})
      // commit("setStoreTeacherEvents", {})
      // // commit("setStudentUpcomingClass", {})
      // // commit("setStudentPastClass", {})
      // commit("setLogs", {})
      // commit("setLogsData", {})
      // commit("setAdminPackages", {})
      // commit("Student/setStudentData", {})

    },
    AddStudent ({
      commit
    }, data) {
      return new Promise(function (resolve, reject) {
        commit('setLoading', {
          loading: true
        })
        api.postData('admin/teacher/signup', data).then(res => {
            commit('setLoading', {
              loading: false
            })
            resolve(res)
          })
          .catch((error) => {
            commit('setLoading', {
              loading: false
            })
            reject(error)
          })
      })
    },
    AddTeacher({
      commit
    }, data) {
      return new Promise(function (resolve, reject) {
        commit('setLoading', {
          loading: true
        })
        api.postData('admin/teacher/signup', data).then(res => {
            commit('setLoading', {
              loading: false
            })
            resolve(res)
          })
          .catch((error) => {
            commit('setLoading', {loading: false})
            reject(error)
          })
      })
    },
    getAllClasses ({commit}) {
      commit('setLoading', { loading: true })
      api.getData('admin/module').then(res => {
        var modules = res.Data
        commit('setModulesData', modules)
        commit('setLoading', { loading: false })
      })
    },
    getAllPackages({
      commit
    }) {
      commit('setLoading', {
        loading: true
      })
      api.getData('admin/package').then(res => {
        var packages = res.data
        commit('setPackagesData', packages)
        commit('setLoading', {
          loading: false
        })
      })
    },
    getEarningsTotalAmount({
      commit
    }) {

      api.getData('driver/earning').then(res => {
        const data = res.data
        commit('setEarningsData', data)
        // let items=[]
        commit('setLoading', {
          loading: false
        })
      })
    },
    GetStudentCounts() {
      // axios
      // .get('')
      // .then()
      // .catch(error =>{
      // });
      // api.getData('').then(res=>{
      // }
    },
    getStudentData ({commit}) {
      commit("setLoading", { loading: true });
      api.getData("admin/student").then(res => {
          const data = res.data;
          commit("setStudentData", data)
          commit("setLoading", { loading: false });
          //dispatch('getStudentClass', {'studentid':this.studentId, 'packageid':packageId});
      });
  },
  getClassById ({ commit }, id) {
    // commit('setLoading', { loading: true })
    if (id) {
      api.getData('admin/module/' + id).then(
            res => {
              const modules = res.data
              commit('setModulesData', { modules })
            },
            err => {
            }
        )
    }
  },
     getTeacherData({commit}){
      commit("setLoading", { loading: true });
      api.getData("admin/teacher").then(res => {
          const data = res.data;
          commit("setTeacherData", data)
          commit("setLoading", { loading: false });
      });
  },
  loadAdminPackages({
    commit
  }) {
    api.postData("auth/driver/products").then(res => {
      commit("setAdminPackages", res.data);
    });
  },
  addAdmin({commit,dispatch}, admin) {
    // delete admin.address;
    return new Promise((resolve, reject) => {
      if (true) {
        // admin['gender'] = admin['gender'].toLowerCase();
        api.postData("auth/signup", admin)
          .then(res => {
            const adminRes = res.data.user;

            // commit("setadmin", { adminRes });
            commit("setToken", res.data.token)
            commit("setadmin", {adminRes});

            // sendSuccessNotice(commit, "New admin has been added.");
            // closeNotice(commit, 1500);
            resolve(res);
          })
          .catch(err => {
            reject(err)
            // sendErrorNotice(commit, "Operation failed! Please try again later. ");
            // closeNotice(commit, 1500);
          });
      } else {
        api
          .putData("admins/" + admin.id.toString(), admin)
          .then(res => {
            const admin = res.data;
            commit("setadmin", {
              admin
            });
            sendSuccessNotice(commit, "admin has been updated.");
            closeNotice(commit, 1500);
            resolve(res);
          })
          .catch(err => {
            sendErrorNotice(commit, "Operation failed! Please try again later. ");
            closeNotice(commit, 1500);
            resolve(res);
          });
      }
    })
  },

  addClub({commit,dispatch}, club) {
    // delete club.address;
    if (!club.id) {
      var formData = new FormData();
      formData.append('club_name', club.club_name);
      formData.append('club_email', club.club_email);
      formData.append('club_phone', club.club_phone);
      formData.append('city', club.city);
      formData.append('door', club.door);
      formData.append('floor', club.floor);
      formData.append('streetNumber', club.streetNumber);
      formData.append('zipCode', club.zipCode);
      formData.append('admin_id', club.admin_id);
      formData.append('admin_package_id', club.admin_package_id);
      // formData.append('description', club.description);
      // formData.append('benefit', club.benefit);
      // formData.append('attachment', club.attachment);
      // formData.append('start_date', club.start_date);
      // formData.append('opendays', club.opendays);
      // formData.append('club_start_time', club.club_start_time);
      // formData.append('club_end_time', club.club_end_time);
      // formData.append('club_logo', club.club_logo);
      // formData.append('club_cover', club.club_cover);
      formData.append('cvr_number', club.cvr_number);
      api
        .postData("admin/club/create", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(res => {
          const club = res.data;
          commit("setclub", {
            club
          });
          sendSuccessNotice(commit, "New club has been added.");
          closeNotice(commit, 1500);
          // window.location.replace("/customers");
          // this.$router.push('/customers');

        })
        .catch(err => {
          sendErrorNotice(commit, "Operation failed! Please try again later. ");
          closeNotice(commit, 1500);
        });
    } else {
      api
        .putData("club/" + club.id.toString(), club)
        .then(res => {
          const club = res.data;
          commit("setclub", {
            club
          });
          sendSuccessNotice(commit, "Club has been updated.");
          closeNotice(commit, 1500);
        })
        .catch(err => {
          sendErrorNotice(commit, "Operation failed! Please try again later.");
          closeNotice(commit, 1500);
        });
    }
  },

  AddPayment ({commit}, data) {
    return new Promise(function (resolve, reject) {
      commit('setLoading', {loading: true})
        api.postData('admin/pay/new', data).then(res => {
          commit('setLoading', {loading: false})
          resolve(res)
        })
        .catch((error) => {
          commit('setLoading', {loading: false})
          reject(error)
        })
    })
  },
// **************************************************************************************** Justin Ajith
    getAllEarnings({commit}) {

      api.getData("admin/earning/statement").then(res => {
        const data = res.data;
        commit("setEarningsStatementData", data)
        let items = [];
        // commitPagination(commit, data);
        commit("setLoading", {
          loading: false
        });
      });
    },
    setLocations({commit,state},data){
      commit('setLocations',data)
    },
    getTotalEarning({commit}) {

      api.getData("admin/earning").then(res => {
        const data = res.data;
        commit("setTotalEarning", data)
        // commitPagination(commit, data);
        commit("setLoading", {
          loading: false
        });
      });
    },
    withdrawalRequest({commit}, amount) {
      commit("setLoading", {loading: true});
      api.postData("admin/request/create", {"request_amount":amount}).then(res => {
        const data = res.data;
        commit("setLoading", {
          loading: false
        });
      });
    },
    Login({ commit, dispatch }){
      api.getData("admin/earning/monthWise").then(res => {
        const data = res.data;
        commit("setEarningChart", data);
        // commitPagination(commit, data);
        commit("setLoading", {loading: false});

        api.postData("admin/monthWise/student").then(res => {
          const data = res.data;
          commit("setStudentChart", data);
          // commitPagination(commit, data);
          commit("setLoading", {loading: false});
        });
      });

      api.getData("admin/cancel/teacher/month").then(res => {
        const data = res.data;
        commit("setTeacherChart", data);
        commit("setLoading", {loading: false});
        // console.log("all are set")
        setTimeout(() => {
         router.push('/');
        }, 800);
      }).catch(err=>{
        router.push('/');
      });
    },
      getEarningChart({commit}) {
          commit("setLoading", {loading: true});
          api.getData("admin/earning/monthWise").then(res => {
              const data = res.data;
              commit("setEarningChart", data);
              // commitPagination(commit, data);
              commit("setLoading", {
                  loading: false
              });
          });
      },

      getStudentChart({commit}) {
          commit("setLoading", {loading: true});
          api.postData("admin/monthWise/student").then(res => {
              const data = res.data;
              commit("setStudentChart", data);
              // commitPagination(commit, data);
              commit("setLoading", {
                  loading: false
              });
          });
      },

      getTeacherChart({commit}) {
          commit("setLoading", {loading: true});
          api.getData("admin/cancel/teacher/month").then(res => {
              const data = res.data;
              commit("setTeacherChart", data);
              commit("setLoading", {
                  loading: false
              });
          });
      },

      getSingleStudentDetails({commit,dispatch}, student) {
          api.getData("admin/student/"+student).then(res => {
              const data = res.data;
              commit("setStudentDetails", data);
              commit("setLoading", {
                  loading: false
              });
              var FormData={
                studentid:res.data.id,
                packageid:res.data.packages[0].id
              }
              dispatch('getStudentClass',FormData)
          });
      },
      getStudentFullClasses({commit}, data) {
        commit("setLoading", {loading: true});
          api.postData("admin/studentFullClasses", {'student_id':data.studentid})
          .then(res => {
            const data = res.data;
            commit("setStudentFullClass", data);
            commit("setLoading", {loading: false});
          }).catch(err=>{
            commit("setStudentFullClass", []);
            commit("setLoading", {loading: false});
          });
      },
      getStudentClass({commit}, data) {
        commit("setLoading", {loading: true});
        api.postData("admin/student_class", {'student_id':data.studentid, 'package_id':data.packageid}).then(res => {
            const data = res.data;
            commit("setStudentClass", data);
            commit("setLoading", {loading: false});
        });
    },

      getTeacherEvents({commit}, teacher) {
          commit("setLoading", {loading: true});
          api.getData("admin/get-teacher-event/"+teacher).then(res => {
              const data = res.data;
              commit("setTeacherEvents", data);
              commit("setLoading", {
                  loading: false
              });
          });
      },

      storeTeacherEvents({commit}, data) {
          commit("setLoading", {loading: true});
          api.postData(`admin/teacher-event/${data.teacher}`, data.datas).then(res => {
              const data = res.data;
              commit("setStoreTeacherEvents", data);
              commit("setLoading", {
                  loading: false
              });
          });
      },

      getTeacherClasses({commit,dispatch}, teacher_id) {
        commit("setTeacherClasses", []);
        commit("setLoading", {loading: true});
        api.postData("admin/teacher_classes", {'teacher_id': teacher_id})
        .then(res => {
          const teacher = res.data;
          commit("setTeacherClasses", teacher);
          commit("setLoading", {
              loading: false
          });
      });
      },
      // getStudentUpcomingClass({commit}, student) {
      //     commit("setLoading", {loading: true});
      //     api.postData("student/viewUpcomingBookings/").then(res => {
      //         const data = res.data;
      //         commit("setStudentUpcomingClass", data);
      //         commit("setLoading", {
      //             loading: false
      //         });
      //     });
      // },
      // getStudentPastClass({commit}, student) {
      //     commit("setLoading", {loading: true});
      //     api.postData("student/ViewPastBookings/").then(res => {
      //         const data = res.data;
      //         commit("setStudentPastClass", data);
      //         commit("setLoading", {
      //             loading: false
      //         });
      //     });
      // },

      updateCancelTime({commit}, cancellation_time_period) {
          commit("setLoading", {loading: true});
          api.postData("admin/club/setting", {'cancellation_time_period':cancellation_time_period}).then(res => {
              const data = res.data;
              commit("setLoading", {
                  loading: false
              });
          });
      },
      confirmMail({commit}, id){
        new Promise(function(resolve,reject){
          api.getData("auth/confirmEmail/"+id)
          .then(res => {
            resolve(res)
            if(res.status==200){
              let success=false
              let msg="Your email already Confirmed"
              commit('setMsg',{success,msg})
            }else if(res.status==201){
              let success=true
              let msg="Your email has been verified"
              commit('setMsg',{success,msg})
              setTimeout(() => {
                router.push('/login');
              }, 2000)
            }else if(res.status==404){
              let success=false
              let msg="Url not found"
              commit('setMsg',{success,msg})
            }else{
              let success=false
              let msg="Confirmation Failed"
              commit('setMsg',{success,msg})
            }
          })
          .catch(function (error) {
            let success=false
            let msg="Url not found"
            commit('setMsg',{success,msg})
          })

        })
      },
      verifyMail({commit}, id){
        new Promise(function(resolve,reject){
          api.getData("auth/changeEmail/"+id)
          .then(res => {
            resolve(res)
            if(res.status==200){
              let success=false
              let msg="Your email already Confirmed"
              commit('setMsg',{success,msg})
            }else if(res.status==201){
              let success=true
              let msg="Your email has been verified"
              commit('setMsg',{success,msg})
              setTimeout(() => {
                router.push('/login')
              }, 2000)
            }else if(res.status==404){
              let success=false
              let msg="Url not found"
              commit('setMsg',{success,msg})
            }else{
              let success=false
              let msg="Confirmation Failed"
              commit('setMsg',{success,msg})
            }
          })
          .catch(function (error) {
            let success=false
            let msg="Url not found"
            commit('setMsg',{success,msg})
          })

        })
      },
      setChatMessages({commit}, {data}){
        let messages=data.messages
        let id=data.id
        // let chatId=data.chatId
        // let messages=data.messages
        // console.log(chatId)
        // console.log(messages)
        commit('setChatMessages',{messages,id})
      },
      setEmptyChatMessages(){
        commit('setEmptyChatMessages')
      },
      pushChatMessages({commit}, {msg}){
        // let chatId=data.chatId
        // let messages=data.messages
        // console.log(chatId)
        // console.log(messages)
        commit('pushChatMessages',{msg})
      },

  }
})



// WEBPACK FOOTER //
// ./src/store/index.js